import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ElementRef, Injectable } from '@angular/core';

import { PopoverConfig } from './model';

/**
 * Popover overlay service
 */
@Injectable()
export class PopoverService {
  /** Dependencies. */
  constructor(private overlay: Overlay) {}

  /**
   * Returns overlay for popover.
   * @param elementRef Origin element to attach Popover to.
   */
  public createOverlay(
    elementRef: ElementRef<HTMLElement>,
    config?: PopoverConfig,
    width?: number,
    closeOnScroll: boolean = true,
    hasBackdrop = true,
  ): OverlayRef {
    const defaultConfig: PopoverConfig = {
      xOffset: 0,
      yOffset: 5,
    };

    config = config || defaultConfig;

    const positionStrategy = this.overlay
      .position()
      .flexibleConnectedTo(elementRef)
      .withTransformOriginOn('.popover')
      .withFlexibleDimensions(false)
      .withViewportMargin(10)
      .withPush(true)
      .withDefaultOffsetX(config.xOffset)
      .withDefaultOffsetY(config.yOffset);

    return this.overlay.create({
      width,
      hasBackdrop,
      backdropClass: 'cdk-overlay-transparent-backdrop',
      positionStrategy,
      scrollStrategy: closeOnScroll
        ? this.overlay.scrollStrategies.close()
        : this.overlay.scrollStrategies.noop(),
    });
  }
}
